import { Suspense } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ReturnWorkflowsProvider } from "@babackapp/workflows-editor/return-provider";
import { WorkflowsEditorCore } from "@babackapp/workflows-editor/workflows-editor";

export default function ReturnWorkflowsPage() {
  const { shopId } = useParams<{ shopId: string }>();

  if (!shopId) return null;

  return (
    <Suspense fallback={null}>
      <ReturnWorkflowsEditor shopId={shopId} />
    </Suspense>
  );
}

/**
 * Serves both the listing route (no :workflowId) and the editor route — the
 * editor core renders its own listing sidebar and empty state, exactly like
 * the track-office host.
 */
function ReturnWorkflowsEditor({ shopId }: { shopId: string }) {
  const { workflowId } = useParams<{ workflowId: string }>();
  const navigate = useNavigate();

  function handleWorkflowSelect(selectedId: string | undefined) {
    if (selectedId) {
      navigate(
        `/shops/${shopId}/settings/notifications/workflows/${selectedId}`,
        { replace: true },
      );
    }
  }

  return (
    <ReturnWorkflowsProvider
      shopId={shopId}
      openTemplate={(templateId) =>
        navigate(
          `/shops/${shopId}/settings/notifications/email-templates/${templateId}`,
        )
      }
    >
      <div className="absolute inset-0">
        <WorkflowsEditorCore
          currentWorkflowId={workflowId}
          devMode={import.meta.env.DEV}
          onWorkflowSelect={handleWorkflowSelect}
        />
      </div>
    </ReturnWorkflowsProvider>
  );
}
